module.exports = __webpack_public_path__ + "media/images/google-play-badge-e3b4d9a1.png";